import { Reducer } from 'redux';
import { AreaOfInterestActionTypes, AreaOfInterestState } from 'types';

const initialState: AreaOfInterestState = {
  shapeFile: null,
  previewIdFromFile: null,
  geoJsonFromLGA: null,
  uploadState: 'initial',
  geoJson: null,
  aoiUpdateMode: 'map',
  updateState: 'initial',
  errMsg: '',
  loadingState: 'initial',
  aoiList: null,
  currentInfo: null,
  previewInfo: null,
  clippedWarning: '',
  lgaOptions: null
};

const reducer: Reducer<AreaOfInterestState> = (
  state = initialState,
  action: any
) => {
  switch (action.type) {
    case AreaOfInterestActionTypes.UPLOAD_SHAPE_FILE_START: {
      return {
        ...state,
        shapeFile: action.payload.shapeFile,
        previewIdFromFile: null,
        uploadState: 'processing',
        errMsg: ''
      };
    }
    case AreaOfInterestActionTypes.UPLOAD_SHAPE_FILE_SUCCESS: {
      return {
        ...state,
        previewIdFromFile: action.payload,
        uploadState: 'success',
        errMsg: ''
      };
    }
    case AreaOfInterestActionTypes.UPLOAD_SHAPE_FILE_FAILURE: {
      return {
        ...state,
        shapeFile: null,
        previewIdFromFile: null,
        uploadState: 'fail',
        errMsg: action.payload
      };
    }
    case AreaOfInterestActionTypes.CANCEL_UPLOAD_SHAPE_FILE: {
      return {
        ...state,
        shapeFile: null,
        uploadState: 'initial',
        errMsg: ''
      };
    }
    case AreaOfInterestActionTypes.PUT_NEW_AOI_START: {
      return {
        ...state,
        updateState: 'processing',
        errMsg: ''
      };
    }
    case AreaOfInterestActionTypes.PUT_NEW_AOI_SUCCESS: {
      return {
        ...state,
        shapeFile: null,
        previewIdFromFile: null,
        uploadState: 'initial',
        geoJson: null,
        aoiUpdateMode: 'map',
        updateState: 'success',
        previewInfo: null,
        clippedWarning: '',
        errMsg: '',
        previewId: undefined
      };
    }
    case AreaOfInterestActionTypes.PUT_NEW_AOI_FAILURE:
      return {
        ...state,
        shapeFile: null,
        previewIdFromFile: null,
        geoJsonFromLGA: null,
        uploadState: 'initial',
        geoJson: null,
        aoiUpdateMode: 'map',
        updateState: 'fail',
        previewInfo: null,
        clippedWarning: '',
        errMsg: action.payload,
        previewId: undefined
      };
    case AreaOfInterestActionTypes.REVERT_NEW_AOI:
      return {
        ...state,
        shapeFile: null,
        previewIdFromFile: null,
        geoJsonFromLGA: null,
        uploadState: 'initial',
        geoJson: null,
        aoiUpdateMode: 'map',
        updateState: 'initial',
        previewInfo: null,
        clippedWarning: '',
        errMsg: '',
        previewId: undefined
      };
    case AreaOfInterestActionTypes.UPDATE_GEOJSON_FROM_MAP:
      return {
        ...state,
        aoiUpdateMode: 'map',
        geoJson: action.payload
      };
    case AreaOfInterestActionTypes.UPDATE_GEOJSON_FROM_BOUNDARY:
      return {
        ...state,
        aoiUpdateMode: 'boundary',
        geoJson: action.payload,
        geoJsonFromLGA: null
      };
    case AreaOfInterestActionTypes.GET_AOI_LIST_START: {
      return {
        ...state,
        loadingState: 'processing',
        errMsg: ''
      };
    }
    case AreaOfInterestActionTypes.GET_AOI_LIST_SUCCESS: {
      return {
        ...state,
        loadingState: 'success',
        aoiList: action.payload,
        errMsg: ''
      };
    }
    case AreaOfInterestActionTypes.GET_AOI_LIST_FAILURE: {
      return {
        ...state,
        loadingState: 'fail',
        aoiList: null,
        errMsg: action.payload
      };
    }
    case AreaOfInterestActionTypes.GET_CURRENT_AOI_INFO_START: {
      return {
        ...state,
        currentInfo: null
      };
    }
    case AreaOfInterestActionTypes.GET_CURRENT_AOI_INFO_SUCCESS: {
      return {
        ...state,
        currentInfo: action.payload
      };
    }
    case AreaOfInterestActionTypes.GET_CURRENT_AOI_INFO_FAILURE: {
      return {
        ...state,
        currentInfo: action.payload
      };
    }
    case AreaOfInterestActionTypes.GET_PREVIEW_AOI_INFO_START: {
      return {
        ...state,
        previewInfo: null,
        previewId: undefined
      };
    }
    case AreaOfInterestActionTypes.GET_PREVIEW_AOI_INFO_SUCCESS: {
      return {
        ...state,
        previewInfo: action.payload
      };
    }
    case AreaOfInterestActionTypes.GET_PREVIEW_AOI_INFO_FAILURE: {
      return {
        ...state,
        previewInfo: action.payload
      };
    }
    case AreaOfInterestActionTypes.SET_AOI_CLIPPED_OBJECT: {
      return {
        ...state,
        clippedWarning: action.payload.warning
      };
    }
    case AreaOfInterestActionTypes.UNLOAD_AOI_PAGE: {
      return initialState;
    }
    case AreaOfInterestActionTypes.GET_LGA_BOUNDARIES_OPTION_SUCCESS: {
      return {
        ...state,
        lgaOptions: action.payload
      };
    }
    case AreaOfInterestActionTypes.GET_LGA_BOUNDARIES_OPTION_FAILURE: {
      return {
        ...state,
        lgaOptions: action.payload
      };
    }
    case AreaOfInterestActionTypes.GET_LGA_BOUNDARY_START: {
      return {
        ...state,
        geoJsonFromLGA: null,
        uploadState: 'processing',
        errMsg: ''
      };
    }
    case AreaOfInterestActionTypes.GET_LGA_BOUNDARY_SUCCESS: {
      return {
        ...state,
        geoJsonFromLGA: action.payload,
        uploadState: 'success',
        errMsg: ''
      };
    }
    case AreaOfInterestActionTypes.GET_LGA_BOUNDARY_FAILURE: {
      return {
        ...state,
        geoJsonFromLGA: null,
        uploadState: 'fail',
        errMsg: action.payload
      };
    }
    case AreaOfInterestActionTypes.INTIAL_AOI_PAGE_START: {
      return {
        ...state,
        currentActiveAoiId: undefined,
        loadingState: 'processing',
        errMsg: ''
      };
    }
    case AreaOfInterestActionTypes.INTIAL_AOI_PAGE_SUCCESS: {
      return {
        ...state,
        loadingState: 'success',
        currentActiveAoi: action.payload.currentActiveAoi,
        aoiList: action.payload.aoiList,
        errMsg: ''
      };
    }
    case AreaOfInterestActionTypes.INTIAL_AOI_PAGE_FAILURE: {
      return {
        ...state,
        loadingState: 'fail',
        currentActiveAoiId: undefined,
        aoiList: null,
        errMsg: action.payload
      };
    }
    case AreaOfInterestActionTypes.SET_LAST_VISIT_LIST_PAGE: {
      return {
        ...state,
        lastVisitListPage: action.payload
      };
    }
    case AreaOfInterestActionTypes.SET_AOI_PREVIEW_ID: {
      return {
        ...state,
        previewId: action.payload.previewId
      };
    }
    default: {
      return state;
    }
  }
};

export { reducer as AreaOfInterestReducer };
